import { ff_ajax } from 'js/utils';
import { global_hooks } from 'src/globals';

global_hooks.on('listing/init', init);

function init(listing) {
	const post_count = parseInt(listing.args.post_count);
	const found_posts = parseInt(listing.args.found_posts);

	let loading = true;
	let load_all_complete = null;

	listing.wait_load_all = async () => {
		if (!loading) return true;
		return new Promise((resolve) => {
			load_all_complete = resolve;
		});
	};

	const complete = () => {
		loading = false;
		if (load_all_complete) load_all_complete();
		listing.hooks.do('load_all/complete', listing);
	};

	if (found_posts <= post_count) {
		return complete();
	}

	const process_result = (res) => {
		if (res.items?.length) {
			res.items.forEach((item) => {
				listing.hooks.do('item/add', item);
			});
		}
		complete();
	};

	const payload = { query_args: listings_data.query_args, post_count };
	ff_ajax(listing.args.query_all, payload, (res) => {
		setTimeout(() => process_result(res), 10);
	});
}
